import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';



export const details = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountBalance/${id}`,
        method: 'GET',
    })
};

export const detail = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountBalance/detail/${id}`,
        method: 'GET',
    })
};
